import { IEhrRecordsRepository } from "../../adapters/driven/repositories/ehrRecordsRepository";

export const EhrRecordsServiceImplFactory = ({
  ehrRecordsRepository,
}: {
  ehrRecordsRepository: IEhrRecordsRepository;
}) => {
  const getEhrMedications: IGetEhrMedicationsService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getEhrMedicationsAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getEhrNutrition: IGetEhrNutritionService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getEhrNutritionAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getEhrAssessments: IGetEhrAssessmentsService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getEhrAssessmentsAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getEhrAllergies: IGetEhrAllergiesService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getEhrAllergiesAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getEhrLabs: IGetEhrLabsService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getEhrLabsAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const downloadEhrLab: IDownloadEhrLabService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.downloadEhrLabAPI(payload);
      return { success: true, data: response };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPccAssessments: IGetPccAssessmentsService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getPccAssessmentsAPI(payload);
      return { success: true, data: response };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPccAssessmentDetail: IGetPccAssessmentDetailService = async (
    payload
  ) => {
    try {
      const response = await ehrRecordsRepository.getPccAssessmentDetailAPI(
        payload
      );
      return { success: true, data: response };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getCarePlans: IGetCarePlansService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getCarePlansAPI(payload);
      return { success: true, data: response };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getCarePlanFocuses: IGetCarePlanFocusesService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.getCarePlanFocusesAPI(
        payload
      );
      return { success: true, data: response };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getPccAvailableNoteTypes: IGetPccAvailableNoteTypesService = async (
    payload
  ) => {
    try {
      const response = await ehrRecordsRepository.getPccAvailableNoteTypesAPI(
        payload
      );
      return { success: true, data: response };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const requestPccReconcile: IRequestPccReconcileService = async (payload) => {
    try {
      const response = await ehrRecordsRepository.requestPccReconcileAPI(
        payload
      );
      return { success: true, data: response };
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      return {
        success: false,
        error: { message },
      };
    }
  };

  return {
    getEhrMedications,
    getEhrNutrition,
    getEhrAssessments,
    getEhrAllergies,
    getEhrLabs,
    downloadEhrLab,
    getPccAssessments,
    getPccAssessmentDetail,
    getCarePlans,
    getCarePlanFocuses,
    getPccAvailableNoteTypes,
    requestPccReconcile,
  };
};
